import axiosClient from "./axiosClient";

const contract = {
  // Lưu hợp đồng đã tạo
  saveContractCreated: async (data) => {
    const url = `/contract-instance/create`;
    const response = await axiosClient.post(url, data);
    return response;
  },

  // Lấy danh sách hợp đồng đã tạo
  getListContractCreated: async (params) => {
    const url = `/contract-instance/search`;
    const response = await axiosClient.get(url, { params: params });
    return response;
  },

  // Xóa hợp đồng đã tạo
  deleteContractCreated: async (id) => {
    const url = `/contract-instance/delete?contractId=${id}`;
    const response = await axiosClient.delete(url);
    return response;
  },
  // Xem hợp đồng đã tạo
  getViewContractedCreate: async (params) => {
    const url = `/contract-instance/preview?contractId=${params.contractId}&format=${params.format}`;
    const response = await axiosClient.post(url, {
      responseType: "blob",
    });
    return response;
  },

  // Duyệt hợp đồng đã tạo
  approveContractCreated: async (data) => {
    const url = `/contract-instance/approve`;
    const response = await axiosClient.post(url, data);
    return response;
  },
  // Từ chối hợp đồng đã tạo
  rejectContractCreated: async (data) => {
    const url = `/contract-instance/reject`;
    const response = await axiosClient.post(url, data);
    return response;
  },

  // Chỉnh sửa hợp đồng đã tạo
  updateContractCreated: async (data) => {
    const url = `/contract-instance/update`;
    const response = await axiosClient.put(url, data);
    return response;
  },

  // Xem chi tiết 1 file
  detailContractCreated: async (id) => {
    const url = `/contract-instance/detail?contractId=${id}`;
    const response = await axiosClient.get(url);
    return response;
  },
  // Tạo nhiều hợp đông
  createMultiContract: async (params, id) => {
    console.log("🚀 ~ params:", params);
    const url = `/contract-instance/create-batch?templateId=${id}`;
    const response = await axiosClient.post(url, params, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  },
  // Tải lên nhiều hợp đồng
  downloadContractCreated: async (params) => {
    const url = `/contract-instance/v2/download`;
    const response = await axiosClient.post(url, params, {
      responseType: "blob",
    });
    return response;
  },
  // ---------------------------------------------------------------
  //
  //
  // ---------------------------------------------------------------
  //Gửi chữ Ký bởi khách hàng
  signedContractByCustomer: async (params) => {
    const url = `/contract-customer/contracts/sign`;
    const response = await axiosClient.post(url, params);
    return response;
  },
  // Yêu cầu mã opt
  requestOPT: async (params) => {
    const url = `/contract-auth/request-otp`;
    const response = await axiosClient.post(url, params);
    return response;
  },
  // Xác nhận opt
  verifyOPT: async (params) => {
    const url = `/contract-auth/verify-otp`;
    const response = await axiosClient.post(url, params);
    return response;
  },
  // Xem hợp đồng
  previewContract: async (params) => {
    const url = `/contract-customer/contracts/preview`;
    const response = await axiosClient.post(url, params);
    return response;
  },
  //Tư chối ký
  rejectSignedContract: async (params) => {
    const url = `/contract-customer/contracts/reject`;
    const response = await axiosClient.post(url, params);
    return response;
  },
  // ---------------------------------------------------------------
  //
  //
  // ---------------------------------------------------------------
  // Gửi email tới khách hàng

  // ---------------------------------------------------------------
  //
  //
  // ---------------------------------------------------------------
  // Xóa mẫu hợp đồng
  deleteTemplateContract: async (id) => {
    const url = `/contract-template/delete?id=${id}`;
    const response = await axiosClient.delete(url);
    return response;
  },

  // lấy đanh sách hợp đồng mẫu đã tải lên
  getListContractUpload: async (params) => {
    const url = `/contract-template/search`;
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  // tải lên hợp đồng mẫu
  uploaContract: async (data) => {
    const url = `/contract-template/upload`;
    const response = await axiosClient.post(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  },

  // Lấy danh sách hợp đồng mẫu để tạo hợp đồng
  getListContract: async (params) => {
    const serviceUrl = "/contract-template/search";
    const response = await axiosClient.get(serviceUrl, { params: params });
    return response;
  },

  // Xem hợp đồng đã tải lên
  getViewContractUpload: async (id) => {
    const url = `/contract-template/view?id=${id}`;
    const response = await axiosClient.get(url, {
      responseType: "blob",
    });
    return response;
  },

  // Lấy danh sách các tường trong hợp đồng
  getFieldsContractUpload: async (id) => {
    const url = `/contract-template/fields?id=${id}`;
    const response = await axiosClient.get(url);
    return response;
  },
};

export default contract;
